import React, {
  ComponentProps,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import SingleChoice from "./SingleChoice"
import { ChoiceValue } from "./carAssemblageTypes"
import styles from "./ManualInputs.module.sass"
import TradeInThemeContext from "../TradeInWizard/contexts/theme"
import Info from "../icons/Info.svg?react"
import { trackFunction } from "website_script/lib/iframeTrackingHelper"

type ManualInputsProps = {
  manualInputs: ComponentProps<typeof SingleChoice>["manualInputs"]
  onSubmit: ComponentProps<typeof SingleChoice>["doneCallback"]
  stepName: ComponentProps<typeof SingleChoice>["stepName"]
  values: ChoiceValue
  labels: {
    continue: string
  }
}

const ManualInputs = ({
  manualInputs,
  onSubmit,
  values,
  labels,
  stepName,
}: ManualInputsProps) => {
  const [manulInputValues, setManualInputValues] = useState(values)
  const theme = useContext(TradeInThemeContext)
  const formRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    trackFunction({
      entity: "car_form",
      action: "displayed",
      element: `manual inputs for ${stepName}`,
      flow: "trade_in",
      type: "micro_proceeding",
    })
  }, [])

  useEffect(() => {
    if (formRef.current) {
      formRef.current.style.setProperty("--accent-color", theme.color)
    }
  }, [theme])
  return (
    <div
      ref={formRef}
      className={styles.form}
    >
      <div className={styles.manualInputs}>
        {manualInputs.map((input) => (
          <div key={input.name}>
            <div className={styles.formControl}>
              <label htmlFor={input.name}>
                {input.label}
                {input.required ? "*" : ""}
              </label>
              <input
                id={input.name}
                className="unstyled"
                value={manulInputValues[input.name]}
                onChange={(e) =>
                  setManualInputValues({
                    ...manulInputValues,
                    [input.name]: e.target.value,
                  })
                }
                type={input.type}
                name={input.name}
                placeholder={input.placeholder}
                required={input.required}
              />
            </div>
            {input.hint && (
              <p className={styles.hint}>
                <Info fill="#BBB" width="16" height="16" />{" "}
                <span>{input.hint}</span>
              </p>
            )}
          </div>
        ))}
      </div>
      <button 
        type="button" 
        className={styles.submitButton}
        onClick={(e) => {
          e.preventDefault();
          onSubmit(manulInputValues);
          trackFunction({
            entity: "car_form",
            action: "changed",
            element: `manual inputs for ${stepName}`,
            details: Object.keys(manulInputValues).every(
              (key) => manulInputValues[key]
            )
              ? "filled"
              : "empty",
            flow: "trade_in",
            type: "micro_proceeding",
          });
        }}
      >
        {labels.continue}
      </button>
    </div>
  )
}

export default ManualInputs
